import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';
import { AlertService } from '@core/services/util/alert.service';
import { TokenService } from './security/services/token.service';

enum MenuOrientation {
    STATIC,
    OVERLAY
}
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    menuMode = 'sidebar';

    darkMode = 'dark';

    topbarTheme = 'light';

    menuTheme = 'dark';

    inputStyle = 'outlined';

    ripple: boolean;

    activeTabIndex = -1;

    sidebarActive = false;

    sidebarClick: boolean;

    topbarItemClick: boolean;

    topbarMenuActive: boolean;

    activeTopbarItem: any;

    layoutMode: MenuOrientation = MenuOrientation.STATIC;

    constructor(
        private primengConfig: PrimeNGConfig,
        private translate: TranslateService,
        private tokenService: TokenService,
        private cookieService: CookieService,
        private alertService: AlertService) {
        this.translate.addLangs(['es', 'en', 'pt']);
        this.translate.setDefaultLang('es');
    }

    ngOnInit() {
        this.primengConfig.ripple = true;
    }

    onSidebarClick(event: Event): void {
        this.sidebarClick = true;
    }

    onTabClick(event: Event, index: number): void {
        if (this.activeTabIndex === index) {
            this.sidebarActive = !this.sidebarActive;
        } else {
            this.activeTabIndex = index;
            this.sidebarActive = true;
        }
        event.preventDefault();
    }

    onTopbarMenuButtonClick(event: Event): void {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;
        event.preventDefault();
    }

    onTopbarItemClick(event: Event, item): void {
        this.topbarItemClick = true;
        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }
        event.preventDefault();
    }

    onTopbarSubItemClick(event): void {
        const search = document.location.search.replace('?', '');
        const returnUrl = 'path=' + document.location.pathname + '&' + search;
        event.preventDefault();
        this.tokenService.signOut();
    }

    get overlay(): boolean {
        return this.layoutMode === MenuOrientation.OVERLAY;
    }

    isDesktop(): boolean {
        return window.innerWidth > 1024;
    }

}
